import { render, staticRenderFns } from "./OvertimesList.vue?vue&type=template&id=226bf39f&scoped=true&"
import script from "./OvertimesList.vue?vue&type=script&lang=js&"
export * from "./OvertimesList.vue?vue&type=script&lang=js&"
import style0 from "./OvertimesList.vue?vue&type=style&index=0&id=226bf39f&lang=scss&scoped=true&"
import style1 from "./OvertimesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bf39f",
  null
  
)

export default component.exports